import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    title: {
      ...CommonFonts.darkFont16,
      fontWeight: '600',
    },
    boxInput: {
      marginTop: theme.spacing(10),
    },
    labelOption: {
      ...CommonFonts.blueFont14,
      margin: theme.spacing(0, 7),
    },
  })
);

export default useStyles;
